module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    attrs: {
      "id": "modal"
    }
  }, [_c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask",
    on: {
      "click": this.hideModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header")], true), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_c('div', {
    attrs: {
      "id": "alert-dialog"
    }
  }, [_c('div', {
    staticClass: "alert-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "alert-message"
  }, [_c('h1', [_vm._v("Ooops!")]), _vm._v(" "), _c('p', [_vm._v("You need to \"Pledge to run\" to access the resources and get running reminders.")])])])])], true), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('div', {
    staticClass: "close-button",
    on: {
      "click": this.hideModal
    }
  }, [_vm._v("\n                Close\n              ")])])], true)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6ec9e31b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = 107
// module chunks = 2